import type { IApiResponse } from "@litres-libs/types";
import type { SurveyRedirectUrl, Survey } from "./survey.types";
import { rtkqApi } from "../api/rtkqApi";

export const cancelSubscriptionSurveyApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    cancelSubscription: build.query<
      SurveyRedirectUrl | null,
      { id: number; auto_renew_status: number }
    >({
      query: ({ id, auto_renew_status }) => ({
        url: `/foundation/api/users/me/subscriptions/${id}/auto-renew-status`,
        method: "PUT",
        body: {
          auto_renew_status,
        },
      }),
      transformResponse: (response: IApiResponse<SurveyRedirectUrl | null>) => {
        if (response) {
          return response.payload.data;
        }
        return null;
      },
    }),
    getPoll: build.query<Survey, { id: string }>({
      query: ({ id }) => ({
        url: `/foundation/api/polls/${id}`,
      }),
      transformResponse: (response: IApiResponse<Survey>) =>
        response.payload.data,
    }),
    sendPollResults: build.mutation<
      IApiResponse<Survey>,
      {
        choice: string | undefined;
        onetime_sid: string | string[] | undefined;
        note?: string | undefined;
        payload?: {
          grant_discount: boolean;
        };
      }
    >({
      query: ({ choice, onetime_sid, note, payload }) => ({
        url: `/foundation/api/poll-votes`,
        method: "POST",
        body: {
          choice,
          onetime_sid,
          note,
          payload,
        },
      }),
    }),
  }),
});
